import api from "shared/infra/services/api";

export const consoleHelpDeskService = {
  getConsoleTickets: async (params) => {
    const {
      data: { data, meta },
    } = await api.get("console/call-center-tickets", {
      params: { ...params, dontVerifyOrg: true },
    });
    return { data, meta };
  },

  getConsoleTicketsDetails: async (ticketId: number) => {
    const { data } = await api.get(`console/call-center-tickets/${ticketId}`, {
      params: { dontVerifyOrg: true },
    });
    return data;
  },

  getConsoleTicketsMetrics: async () => {
    const { data } = await api.get("console/call-center-tickets/metrics");
    return data;
  },

  getConsoleOpenTickets: async () => {
    const { data } = await api.get("console/call-center-tickets/open");
    return data;
  },

  postUpdateTicketAction: async (id: number, status) => {
    const { data } = await api.post(
      `console/call-center-tickets/action/${id}`,
      { status },
      {
        params: {
          dontVerifyOrg: true,
        },
      },
    );

    return data;
  },

  postCloseTicketAction: async (id: number) => {
    const { data } = await api.post(
      `console/call-center-tickets/finalize/${id}`,
      { params: { dontVerifyOrg: true } },
    );

    return data;
  },
};
